"use client";

import React, { useState } from "react";
import FormStepTwo from "./formStepTwo";

function FormCompany({ majorCompanyId }) {
  const [step, setStep] = useState(0);
  const [activeMoney, setActiveMoney] = useState(0);
  const [data, setData] = useState({
    name_company: "",
    email: "",
    name: "",
    lastName: "",
    identity: "",
    expedition: "",
  });

  const [files, setFiles] = useState({
    rut: "",
    fot_cedula: "",
    cam_comercio: "",
  });

  return (
    <div className="bg-primary text-white rounded-xl p-3 h-fit">
      <p className="text-white text-center text-3xl font-bold mb-3">
        Regístrate como empresa
      </p>
      <div className="bg-white text-black rounded-lg px-2 py-2">
        <FormStepTwo
          setActiveMoney={setActiveMoney}
          activeMoney={activeMoney}
          setStep={setStep}
          setData={setData}
          data={data}
          files={files}
          setFiles={setFiles}
          majorCompanyId={majorCompanyId}
          black
        />
      </div>
    </div>
  );
}

export default FormCompany;
